import {
	GET_IN_APP_NOTIFICATIONS_REQUEST,
	GET_IN_APP_NOTIFICATIONS_SUCCESS,
	GET_IN_APP_NOTIFICATIONS_ERROR
} from 'actions/inAppNotificationsActions';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';

export default function inAppNotifications(
	state = {
		isFetching: false,
		notifications: [],
		asyncStatus: INIT
	},
	action = null
) {
	switch (action.type) {
		case GET_IN_APP_NOTIFICATIONS_REQUEST:
			return Object.assign({}, state, { asyncStatus: LOADING });
		case GET_IN_APP_NOTIFICATIONS_SUCCESS:
			return Object.assign(
				{},
				state,
				{
					isFetching: false,
					asyncStatus: SUCCESS
				},
				action.data
			);
		case GET_IN_APP_NOTIFICATIONS_ERROR:
			return Object.assign({}, state, {
				asyncStatus: ERROR,
				error: action.error
			});
		default:
			return state;
	}
}
